/* eslint-disable no-unused-vars */
import * as env from "./env"
import { getAccessToken } from "./auth"
import { SOURCE_TYPE } from "../Config"
import axios from "axios"
import { getCachedClipPointer, cacheClipPointers, selectClipFromData } from "./clipPointerCache"
let gCachedSecrets = null //globalCachedSecrets

// use api enpoint env vars, if set
let taskAPIBaseURL = env.getOperatorBackendAPI() ? env.getOperatorBackendAPI() + "/api/v1" : null
const taskAPIV2BaseURL = env.getOperatorBackendAPI()
  ? env.getOperatorBackendAPI() + "/api/v2"
  : null
let apiURL = taskAPIBaseURL + "/stores/"
let apiV2URL = taskAPIV2BaseURL ? taskAPIV2BaseURL + "/stores/" : null
let zippinApi = env.getZippinPlatformAPI()
let dashboardURL = env.getDashboardUIURL()
let dashboardAPIURL = env.getDashboardServerAPI()
let storeConfigAPI = env.getStoreConfigAPI()
let z_api = env.getZAPI()
let taskAssignerAPI = env.getTaskAssignerService()
let taskAssignmentRuleAPI = env.getTaskAssignmentRuleAPI()
let taskResultIngestorAPI = env.getTaskResultIngestorService()
let trackingAPI = env.getTrackingAPI()
let clipsManagerAPI = env.getClipsManagerAPI()
const mediaProxyServerAPI = env.getMediaProxyServerAPI()
const rbacBaseUrl = env.getRBACBaseUrl()

if (!clipsManagerAPI) {
  clipsManagerAPI = `https://api-dev.zippin.ai/clips-manager`
}

// defaults to gcp test environment if api enpoint env vars are not set
if (!taskAPIBaseURL) {
  taskAPIBaseURL = `https://op-dev-gcp.zippin.ai/api/v1`
}

if (!apiURL) {
  apiURL = `https://op-dev-gcp.zippin.ai/api/v1/stores/`
}
if (!apiV2URL) {
  apiV2URL = `https://op-dev-gcp.zippin.ai/api/v2/stores/`
}
if (!zippinApi) {
  zippinApi = "https://us-central1-zippindeveloper.cloudfunctions.net/api/v1"
}
if (!dashboardURL) {
  dashboardURL = `https://zippindeveloper.appspot.com`
}
if (!z_api) {
  z_api = "https://api-dev.getzippin.com/api"
}

// example once set: "https://test.zippin.ai/api/v1/stores/testlab1";
let apiBaseURL = ""
let apiV2BaseURL = ""

export const DASHBOARD_URL = dashboardURL
export const Z_API_URL = z_api

export function setStoreId(storeId) {
  apiBaseURL = apiURL + storeId
  apiV2BaseURL = apiV2URL + storeId
}

/**
 * Sets common headers such as content-type and authorization.
 */
export const getHeaders = async () => {
  const headers = new Headers()
  headers.append("Content-Type", "application/json")
  const accessToken = await getAccessToken()
  if (!accessToken) {
    throw new Error("Unauthorized")
  }
  headers.append("Authorization", "Bearer " + accessToken)
  return headers
}

/**
 * Sets common fetch params such as headers and calls fetch
 * @param {string} url
 * @param {object} params for fetch
 * @returns fetch result
 */
export const wrappedFetch = async (url, params) => {
  const headers = await getHeaders()
  return await fetch(url, {
    ...params,
    headers,
  })
}

export function getUserTask() {
  return wrappedFetch(`${taskAPIBaseURL}/tasks`, {
    method: "GET",
  })
    .then((response) => {
      if (response.status === 401) {
        throw new Error("Unauthorized")
      } else {
        return response.json()
      }
    })
    .catch((error) => {
      console.error("getUserTaks error: ", error)
      throw new Error("Unauthorized")
    })
}

export function getCameras(storeId) {
  try {
    return wrappedFetch(`${storeConfigAPI}/stores/devices/cameras?storeId=${storeId}`, {
      method: "GET",
    }).then((response) => response.json())
  } catch (e) {
    console.error("getCameras error: ", e)
  }
}

export function editOrder(storeId, orderId, values) {
  let apiEndPoint = `${apiURL}${storeId}/orders/${orderId}/edit`
  return wrappedFetch(apiEndPoint, {
    method: "POST",

    body: JSON.stringify(values),
  }).then((resp) => {
    if (!resp.ok) {
      return { error: true, message: resp.statusText }
    }
    return resp.json()
  })
}
export function getOrder(orderId) {
  try {
    console.log("API getOrder: ", orderId)
    return wrappedFetch(`${apiBaseURL}/orders/${orderId}`, {
      method: "GET",
    }).then((response) => response.json())
  } catch (error) {
    console.error("getOrder error: ", error)
  }
}

export function getOrdersByIds(orderIds) {
  console.log("API getOrder: ", orderIds)
  return wrappedFetch(`${apiBaseURL}/orders-by-ids?ids=${orderIds}`, {
    method: "GET",
  }).then((response) => response.json())
}

export function getOrderEvents(orderId, includeCandidates = true, includeFamily = true) {
  try {
    return wrappedFetch(
      `${apiBaseURL}/orders/${orderId}/events?withEventCams=true&includeCandidates=${
        includeCandidates ? "true" : "false"
      }&includeFamily=${includeFamily ? "true" : "false"}`,
      {
        method: "GET",
      }
    ).then((response) => response.json())
  } catch (error) {
    console.error("getOrderEvents error: ", error)
  }
}
export function getArchivedFrameTimeStamp(cameraId, startTimeStamp, endTimeStamp) {
  return wrappedFetch(
    `${apiBaseURL}/archives/${cameraId}?start=${startTimeStamp}&end=${endTimeStamp}`,
    {
      method: "GET",
    }
  ).then((response) => response.json())
}
export function getFrameTimeStamp(cameraId, startTimeStamp, endTimeStamp) {
  return wrappedFetch(
    `${apiBaseURL}/frames/${cameraId}?start=${startTimeStamp}&end=${endTimeStamp}`,
    {
      method: "GET",
    }
  ).then((response) => response.json())
}
export function getRawAndOrderTracks(cameraId, startTimeStamp, endTimeStamp, taskTrackId) {
  return wrappedFetch(
    `${apiBaseURL}/raw-and-order-tracks/${cameraId}?start=${startTimeStamp}&end=${endTimeStamp}&taskTrackId=${taskTrackId}`,
    {
      method: "GET",
    }
  ).then((response) => response.json())
}

export function getRawTrack(storeId, cameraId, startTimeStamp, endTimeStamp) {
  return wrappedFetch(
    `${trackingAPI}/stores/${storeId}/cameras/${cameraId}/raw-detects?start=${startTimeStamp}&end=${endTimeStamp}&include_keypoints=true`,
    {
      method: "GET",
    }
  ).then((response) => response.json())
}

export function getOrderTrack(storeId, cameraId, startTimeStamp, endTimeStamp) {
  return wrappedFetch(
    `${trackingAPI}/stores/${storeId}/cameras/${cameraId}/track-detects?start=${startTimeStamp}&end=${endTimeStamp}&include_keypoints=true`,
    {
      method: "GET",
    }
  ).then((response) => response.json())
}

export function getEventIndex(startTimeStamp, endTimeStamp) {
  return wrappedFetch(`${apiBaseURL}/events/?start=${startTimeStamp}&end=${endTimeStamp}`, {
    method: "GET",
  }).then((response) => response.json())
}

export function getEvent(eventId) {
  console.log("API getEvent: ", eventId)
  return wrappedFetch(`${apiV2BaseURL}/events/${eventId}`, {
    method: "GET",
  }).then((response) => response.json())
}

export async function getEventsByTime(
  startTimestamp,
  endTimestamp,
  offset = 0,
  count = 100,
  withDetails = false
) {
  try {
    const response = await wrappedFetch(
      `${apiBaseURL}/events-by-time?startTime=${startTimestamp}&endTime=${endTimestamp}&offset=${offset}&count=${count}&withDetails=${withDetails}`,
      {
        method: "GET",
      }
    )
    return response.json()
  } catch (error) {
    console.log(error)
    return null
  }
}

export function getSource(sourceId, sourceType) {
  if (sourceType === SOURCE_TYPE.SHELF) {
    return wrappedFetch(`${apiBaseURL}/shelves/${sourceId}`, {
      method: "GET",
    }).then((response) => response.json())
  } else if (sourceType === SOURCE_TYPE.SOURCE) {
    return wrappedFetch(`${apiBaseURL}/sources/${sourceId}`, {
      method: "GET",
    }).then((response) => response.json())
  } else if (sourceType === SOURCE_TYPE.KIOSK) {
    return wrappedFetch(`${apiBaseURL}/kiosks/${sourceId}`, {
      method: "GET",
    }).then((response) => response.json())
  }
}

export function getProductList() {
  return wrappedFetch(`${apiBaseURL}/products-details`, {
    method: "GET",
  }).then((response) => response.json())
}
export function getProduct(productId) {
  return wrappedFetch(`${apiBaseURL}/products/${productId}`, {
    method: "GET",
  }).then((response) => response.json())
}

export function getRecentOngoingOrders(storeId, end, start, eventEnd) {
  console.log("end = " + end + " start = " + start + " eventEnd = " + eventEnd)
  console.log(
    `${apiURL}${storeId}/recent-ongoing-orders?endTimestamp=${end}&startTimestamp=${start}&eventEnd=${eventEnd}`
  )
  return wrappedFetch(
    `${apiURL}${storeId}/recent-ongoing-orders?endTimestamp=${end}&startTimestamp=${start}&eventEnd=${eventEnd}`,
    {
      method: "GET",
    }
  ).then((response) => response.json())
}

export function removeInactiveUser(taskId) {
  return wrappedFetch(`${taskAPIBaseURL}/task-users/${taskId}`, {
    method: "PUT",
  }).then((response) => response.json())
}

export const queryStoreSkus = async (storeId, query) => {
  let apiEndPoint = `${zippinApi}/stores/${storeId}/skus/query`
  console.log("queryStoreSkus apiEndPoint = " + apiEndPoint)
  let resp = await wrappedFetch(`${apiEndPoint}`, {
    method: "POST",
    body: JSON.stringify({ query }),
  })
  return resp.json()
}

export const queryStoreShelves = async (storeId, query) => {
  let apiEndPoint = `${zippinApi}/stores/${storeId}/shelves/search`
  console.log("queryStoreShelves apiEndPoint = " + apiEndPoint)
  let resp = await wrappedFetch(`${apiEndPoint}`, {
    method: "POST",

    body: JSON.stringify(query),
  })
  return resp.json()
}

export function getShelfProductsMap(storeId) {
  const apiEndPoint = `${apiV2BaseURL}/stores/${storeId}/products-shelf-map`
  return wrappedFetch(`${apiEndPoint}`, {
    method: "GET",
  }).then((resp) => resp.json())
}

export function getShelfInventory(storeId, searchText, page, limit, isExport) {
  let fieldName = ""
  let searchValue = ""
  if (searchText) {
    if (searchText.includes(":")) {
      let splitString = searchText.split(":")
      fieldName = splitString[0].toLowerCase()
      searchText = splitString[1].toLowerCase()
    } else {
      searchText.toLowerCase()
    }
    searchValue = encodeURIComponent(searchText)
  }
  let offset = null
  if (page != null) {
    offset = page * limit
  }
  const apiEndPoint = `${apiBaseURL}/shelves-products-details?field=${fieldName}&search=${searchValue}&limit=${limit}&offset=${offset}&export=${isExport}`
  return wrappedFetch(`${apiEndPoint}`, {
    method: "GET",
  }).then((resp) => resp.json())
}

export function updateActiveUser() {
  return wrappedFetch(`${taskAPIBaseURL}/task-users`, {
    method: "PUT",
  }).then((response) => response.json())
}

/**
 * Saves client error details for alerting & debugging
 * @param {string} errorDetails stringified error details
 */
export const reportError = async (errorDetails) => {
  console.log("reporting error")
  try {
    const resp = await wrappedFetch(`${zippinApi}/app/operator-ui/error`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({
        error: errorDetails,
        userAgent: navigator.userAgent,
        language: navigator.language,
        url: window.location.href,
      }),
    })
    return resp.json()
  } catch (e) {
    console.log(e)
  }
}

export const getStoreLayout = async (storeId, layoutType) => {
  try {
    return await wrappedFetch(`${storeConfigAPI}/stores/${storeId}/layout/${layoutType}`, {
      method: "GET",
    }).then((response) => response.json())
  } catch (e) {
    console.error("getStoreLayout error: ", e)
  }
}

/**
 * Fetches the camera navigations; and transforms the data into a mapping from
 * cameras to each of the other cameras connected by navigational directions.
 * API doc: https://api.zippin.ai/v1/store/swagger.docs/#/Layouts/GetCameraNavigationPairData
 *
 * Example return type
 * { "t01" : {
 *      "left": "t05",
 *      "right":"t02"
 *   },
 *  "t02" : {
 *      "left": "t01",
 *      "right":"t07"
 *   }
 * }
 *
 *
 * @param {string} storeId
 * @returns {Object} the camera navigations
 */

export const getCameraNavigations = async (storeId) => {
  const navigationsResp = await wrappedFetch(
    `${storeConfigAPI}/stores/${storeId}/camera-navigation-pairs`,
    { method: "GET" }
  )
  if (navigationsResp.status !== 200) {
    throw new Error(`Camera navigations API for ${storeId} failed with ${navigationsResp.status}`)
  }
  const navResp = await navigationsResp.json()

  const camDirectionNavigation = {}
  navResp
    // Remove the directions that are not present.
    .filter((nav) => nav.destinationCameraId !== null)
    // Map from source camera to direction to destination camera
    .forEach((nav) => {
      const sourceCamId = nav.sourceCameraId
      if (!(sourceCamId in camDirectionNavigation)) {
        camDirectionNavigation[sourceCamId] = {}
      }
      camDirectionNavigation[sourceCamId][nav.direction] = nav.destinationCameraId
    })
  return camDirectionNavigation
}

export async function getObjAnnotable(storeId, objId) {
  let apiEndPoint = `${Z_API_URL}/stores/${storeId}/annotations/${objId}`
  try {
    return await wrappedFetch(apiEndPoint, {
      method: "GET",
    }).then((resp) => resp.json())
  } catch (e) {
    console.log(e)
  }
}

export async function queryEvents(storeId, dataQuery) {
  try {
    return await wrappedFetch(`${apiURL}${storeId}/events-query`, {
      method: "POST",
      body: JSON.stringify(dataQuery),
    }).then((response) => response.json())
  } catch (e) {
    console.log(e)
  }
}

function constructQueryString(params) {
  if (!params) return ""
  const queryParams = new URLSearchParams()
  if (params.taskId) queryParams.append("task_id", params.taskId)
  if (params.storeIds) queryParams.append("store_id", params.storeIds)
  if (params.taskTypes) queryParams.append("task_type", params.taskTypes)
  if (params.taskStatuses) queryParams.append("status", params.taskStatuses)
  if (params.pendingBy) queryParams.append("pending_by", params.pendingBy)
  return queryParams.toString()
}

export function taskDeepLink(params) {
  try {
    const baseURI = `${taskAssignerAPI}/tasks`
    const queryString = constructQueryString(params)
    const requestURI = baseURI + (queryString ? `?${queryString}` : "")

    return wrappedFetch(requestURI, {
      method: "GET",
    }).then((response) =>
      response.json().then((data) => ({ ...data, statusCode: response.status }))
    )
  } catch (err) {
    console.error(`taskDeepLink`, err)
    throw new Error(`Error while deep linking tasks`)
  }
}

export function taskCount(params) {
  try {
    const baseURI = `${taskAssignerAPI}/tasks/count`
    const queryString = constructQueryString(params)
    const requestURI = baseURI + (queryString ? `?${queryString}` : "")

    return wrappedFetch(requestURI, {
      method: "GET",
    }).then((response) =>
      response.json().then((data) => ({ ...data, statusCode: response.status }))
    )
  } catch (err) {
    console.error(`taskCount`, err)
    throw new Error(`Error while fetching task count`)
  }
}

export const submitTask = async (taskId, results, clipMetrics) => {
  const retries = 3
  let retryCount = 0
  try {
    const data = { results, clip_metrics: clipMetrics }
    while (retryCount < retries) {
      const response = await wrappedFetch(`${taskResultIngestorAPI}/v2/tasks/${taskId}/result`, {
        method: "PUT",
        body: JSON.stringify({ data }),
      })
      if (response.status === 200) {
        return response.json()
      } else {
        console.error(
          `submitTask: Error while submitting the task ${taskId} retryCount: ${retryCount}, response`,
          response
        )
        await new Promise((resolve) => setTimeout(resolve, 500))
        retryCount++
        console.log(`Retrying to submit task ${taskId}, attempt: ${retryCount}`)
      }
    }
  } catch (err) {
    console.error(`Error while submitting the task ${taskId}`, err)
  }
  return { taskId, status: "failed" }
}

export const updateTaskDetails = async (taskId, updates) => {
  try {
    const response = await wrappedFetch(`${taskResultIngestorAPI}/v2/tasks/${taskId}`, {
      method: "PUT",
      body: JSON.stringify(updates),
    })
    if (response.status === 200) {
      return response.json()
    }
    console.error(
      `updateTaskDetails: Error while updating task ${taskId}, status: ${response.status}`
    )
  } catch (err) {
    console.error(`updateTaskDetails: Error while updating task ${taskId}`, err)
  }
  return null
}

export function isExpertOperator() {
  return wrappedFetch(`${taskAssignerAPI}/expert-group-existence`, {
    method: "GET",
  }).then((response) => response.json())
}

export const isUserAuthorizedForTaskAssignment = async () => {
  try {
    const response = await wrappedFetch(`${taskAssignerAPI}/operator/authorize`, {
      method: "GET",
    })
    return response?.status === 200
  } catch (error) {
    console.error(
      `isUserAuthorizedForTaskAssignment: Error while checking user authorization`,
      error
    )
    return false
  }
}

/**
 * Fetches the current user's RBAC permissions.
 */
export const getUserPermissions = async () => {
  const response = await wrappedFetch(`${rbacBaseUrl}/users/me/permissions`, {
    method: "GET",
  })
  if (!response.ok) {
    throw new Error(`getUserPermissions failed with status ${response.status}`)
  }
  return response.json()
}

export async function getConfigKeyValue(storeId, configKey) {
  try {
    const response = await wrappedFetch(
      `${storeConfigAPI}/store-config/stores/${storeId}/configs?sKey=${configKey}`,
      {
        method: "GET",
      }
    )
    if (response.status !== 200) {
      return null
    }
    return response.json()
  } catch (err) {
    console.error(`getConfigKeyValue: Error while fetching ${configKey} of ${storeId}`, err)
    throw new Error(`Error while getting ${configKey} value of ${storeId}`)
  }
}

export async function getCameraSummary(storeId) {
  try {
    const url = `${storeConfigAPI}/stores/${storeId}/clip-manager/camera-summary`
    const response = await wrappedFetch(url, {
      method: "GET",
    })
    return response.json()
  } catch (err) {
    console.error(`getCameraSummary: Error while fetching ${storeId}`, err)
    throw new Error(`Error while getting camera summary of ${storeId}`)
  }
}

export async function getStores() {
  try {
    const url = `${storeConfigAPI}/stores`
    const response = await wrappedFetch(url, {
      method: "GET",
    })
    const responseJson = await response.json()
    let stores = []

    if (Array.isArray(responseJson)) {
      stores = responseJson
    }

    if (stores.length > 0) {
      stores.sort((a, b) => a.name.localeCompare(b.name))
    }
    return stores
  } catch (err) {
    console.error(`getStores`, err)
    throw new Error(`Error while fetching stores`)
  }
}

export async function getSecrets() {
  if (!gCachedSecrets) {
    console.log("getSecrets:: gCachedSecrets is empty")
    let resultJson = null
    if (env.isLocalEnv()) {
      const secretKey = env.getReactAppTurnServerKey(),
        host = env.getReactAppTurnServerHostnames(),
        iceUrl = env.getReactAppIceServerURL(),
        iceUsername = env.getReactAppIceServerCredential(),
        iceCredential = env.getReactAppIceServerUsername(),
        defaultHost = env.getReactAppTurnServerHostnameDefault()
      console.log("getSecrets:: Fetched from process.env - mt-dashboard-ui")
      resultJson = {
        REACT_APP_TURN_SERVER_KEY: secretKey,
        REACT_APP_TURN_SERVER_HOSTNAMES: host,
        REACT_APP_ICE_SERVER_URL: iceUrl,
        REACT_APP_ICE_SERVER_CREDENTIAL: iceUsername,
        REACT_APP_ICE_SERVER_USERNAME: iceCredential,
        REACT_APP_TURN_SERVER_HOSTNAME_DEFAULT: defaultHost,
      }
    } else {
      console.log("getSecrets:: Fetching from process.env - mt-dashboard-server")
      let apiEndPoint = `${dashboardAPIURL}/secrets`
      let response = await wrappedFetch(apiEndPoint, {
        method: "GET",
      })
      resultJson = await response.json()
    }
    gCachedSecrets = resultJson
  } else {
    console.log("getSecrets:: gCachedSecrets is retrieved")
  }
  return gCachedSecrets
}

export async function writeMetricsToTimeseriesDatabase(metrics, database) {
  try {
    const apiEndPoint = `${storeConfigAPI}/metrics/${database}`
    await wrappedFetch(apiEndPoint, {
      method: "POST",
      body: JSON.stringify({
        dataPoints: metrics,
        clientName: "operator-ui",
      }),
    })
  } catch (error) {
    console.error(`writeMetricsToTimeseriesDatabase: Error:`, error)
  }
}

export const getStoreProductsWithShelfIds = async () => {
  try {
    const apiEndPoint = `${apiBaseURL}/products-with-shelfIds`
    const response = await wrappedFetch(`${apiEndPoint}`, {
      method: "GET",
    })
    return response.json()
  } catch (err) {
    console.error(
      `getStoreProductsWithShelfIds: Error in getting store products with shelfIds`,
      err
    )
    return null
  }
}

export const fetchActiveProductsOfStoreBetweenTimestamps = async (start, end) => {
  try {
    const apiEndPoint = `${apiBaseURL}/active-products?start=${start}&end=${end}`
    const response = await wrappedFetch(`${apiEndPoint}`, {
      method: "GET",
    })
    return response.json()
  } catch (err) {
    console.error(
      `fetchActiveProductsOfStoreBetweenTimestampss: Error in fetching active products of store between ${start} and ${end} timestamps`,
      err
    )
    return null
  }
}

/**
 * Get a signed URL for a specific camera snapshot.
 *
 * @param {string} storeId - The ID of the store.
 * @param {string} cameraId - The ID of the camera.
 * @param {number} timestamp - The timestamp for the snapshot.
 * @returns {Promise<string>} A Promise that resolves to the signed URL.
 */
export async function getSignedURL(storeId, cameraId, timestamp, rewind) {
  console.log(
    `getSignedURL: storeId:${storeId}, cameraId:${cameraId}, timestamp:${timestamp}, rewind:${rewind}`
  )

  const cacheKey = `${storeId}-${cameraId}`
  const cachedResult = getCachedClipPointer(cacheKey, timestamp, rewind)
  if (cachedResult) {
    console.log(`getSignedURL: Reusing cached clip pointers for ${cacheKey}`)
    return { requested_timestamp: timestamp, ...cachedResult }
  }

  let clip_filepath,
    ts_filepath,
    next = 0,
    clip_start_ts_ms,
    next_clip_start_ts_ms
  try {
    const startTimestamp = timestamp + 30000
    const endTimestamp = timestamp - 10000
    const apiEndPoint = `${clipsManagerAPI}/api/v1/stores/${storeId}/cameras/${cameraId}/clip-pointers?start=${startTimestamp}&end=${endTimestamp}&offset=0&limit=15&by_score=true&signed_url=true`
    const response = await wrappedFetch(apiEndPoint, {
      method: "GET",
    })
    const obj = await response.json()

    if (obj && obj.data && obj.data.length > 0) {
      cacheClipPointers(cacheKey, obj.data)
      ;({
        clip_filepath,
        ts_filepath,
        clip_start_ts_ms,
        next_clip_start_ts_ms,
        next,
      } = selectClipFromData(obj.data, timestamp, rewind))
    }
  } catch (error) {
    console.error(`getSignedURL: Error:`, error)
  }
  console.log(`clip_filepath:${clip_filepath}`)
  console.log(`ts_filepath:${ts_filepath}`)
  console.log(`clip_start_ts_ms:${clip_start_ts_ms}`)
  console.log(`next_clip_start_ts_ms:${next_clip_start_ts_ms}`)
  return {
    requested_timestamp: timestamp,
    clip_filepath,
    ts_filepath,
    clip_start_ts_ms,
    next_clip_start_ts_ms,
    next,
  }
}

export async function getVideoFromCloud(clip_filepath, ts_filepath) {
  try {
    let result = {}
    const starts = Date.now()
    const requests = []
    requests.push(
      axios.get(clip_filepath, {
        headers: {
          Accept: "video/mp4;charset=UTF-8",
        },
        responseType: "blob",
      })
    )
    requests.push(axios.get(ts_filepath))
    let responses = await axios.all(requests)

    responses.forEach((resp) => {
      if (resp["headers"][`content-type`] === "video/mp4") {
        result["content"] = resp.data
      } else {
        result["ts"] = resp.data
      }
    })
    const ends = Date.now()
    console.log(`Time taken for video and ts file to download:${ends - starts}`)
    return result
  } catch (error) {
    console.error(`getVideoByURL: Error:`, error)
  }
}

export const getEntryCamera = async (source) => {
  try {
    const response = await wrappedFetch(`${apiBaseURL}/entries/${source}`, {
      method: "GET",
    })
    if (response?.status === 200) {
      return response.json()
    }
  } catch (err) {
    console.error(`getEntryCamera: Error while getting camera for ${source}`, err)
  }
  return null
}

export const getOperatorActivityTypes = async () => {
  try {
    const response = await wrappedFetch(`${taskAssignerAPI}/operatorActivityTypes`, {
      method: "GET",
    })
    if (response?.status === 200) {
      return response.json()
    }
  } catch (err) {
    console.error(`getOperatorActivityTypes: Error while getting Operator Activity Types`, err)
  }
  return null
}

export const getOperatorCurrentActivity = async (userId) => {
  try {
    const response = await wrappedFetch(
      `${taskAssignerAPI}/operatorCurrentActivity/${encodeURIComponent(userId)}`,
      {
        method: "GET",
      }
    )
    if (response?.status === 200) {
      return response.json()
    }
  } catch (err) {
    console.error(`getOperatorCurrentActivity: Error while getting operator activity`, err)
  }
  return null
}

export const saveOperatorCurrentActivity = async (userId, activityId) => {
  try {
    await wrappedFetch(`${taskAssignerAPI}/operatorCurrentActivity`, {
      method: "POST",
      body: JSON.stringify({
        userId,
        activityId,
      }),
    })
  } catch (error) {
    console.error(
      `saveOperatorCurrentActivity: Error while saving operator activity. ${JSON.stringify(error)}`
    )
  }
}

export const fetchTaskDetails = async (taskId) => {
  try {
    const response = await wrappedFetch(`${taskAssignerAPI}/tasks/${taskId}/details`, {
      method: "GET",
    })
    if (response?.status === 200) {
      return response.json()
    }
  } catch (err) {
    console.error(`fetchTaskDetails:`, err)
  }
  return null
}

export const getTaskTypes = async () => {
  try {
    const response = await wrappedFetch(`${taskAssignerAPI}/task-types`, {
      method: "GET",
    })
    return response.json()
  } catch (err) {
    console.error(`getTaskTypes:`, err)
  }
  return null
}

export const getActiveAssignmentRulesForUser = async (member) => {
  try {
    const response = await wrappedFetch(
      `${taskAssignmentRuleAPI}/assignment-rules?member=${encodeURIComponent(member)}&active=true`,
      {
        method: "GET",
      }
    )
    return response.json()
  } catch (err) {
    console.error(`getActiveAssignmentRulesForUser:`, err)
  }
  return null
}

export const getCurrentUserRole = async (storeId) => {
  try {
    const apiEndPoint = `${apiBaseURL}/users/current`
    const response = await wrappedFetch(`${apiEndPoint}`, {
      method: "GET",
    })
    return response.json()
  } catch (err) {
    console.error(`getCurrentUserRole: ${storeId} error:`, err)
  }
  return null
}

export const getUserRoleMapping = async (userId) => {
  try {
    const apiEndPoint = `${storeConfigAPI}/stores/user-role-mapping?userId=${encodeURIComponent(
      userId
    )}`
    const response = await wrappedFetch(`${apiEndPoint}`, {
      method: "GET",
    })
    return response.json()
  } catch (err) {
    console.error(`getUserRoleMapping: user: ${userId} error:`, err)
  }
  return null
}

export const getStoreNetworkInfo = async (storeId) => {
  try {
    const response = await wrappedFetch(`${storeConfigAPI}/stores/${storeId}/store-network-info`, {
      method: "GET",
    })
    return response.json()
  } catch (err) {
    console.log(`Error in fetching store network details for ${storeId}: `, err)
    return null
  }
}

const ensureMediaProxyResponseOk = async (
  response,
  serverHost,
  serverPort,
  timestamp,
  fileType
) => {
  if (response?.ok) {
    return
  }
  let errorMessage = `Media proxy ${fileType} request failed for ${serverHost}:${serverPort} at ${timestamp}`
  try {
    const errorBody = await response.json()
    if (errorBody?.detail) {
      errorMessage = `${errorMessage}. Detail: ${errorBody.detail}`
    }
  } catch (err) {
    // ignore json parse errors
  }
  throw new Error(errorMessage)
}

export const getVideoFromMediaProxy = async (serverHost, serverPort, timestamp) => {
  if (!mediaProxyServerAPI) {
    throw new Error("Media proxy base URL is not configured")
  }
  const urlBase = `${mediaProxyServerAPI}/files/${serverHost}/${serverPort}/${timestamp}`
  const [mp4Response, tsResponse] = await Promise.all([
    wrappedFetch(`${urlBase}?file_type=mp4`, { method: "GET" }),
    wrappedFetch(`${urlBase}?file_type=ts`, { method: "GET" }),
  ])

  await Promise.all([
    ensureMediaProxyResponseOk(mp4Response, serverHost, serverPort, timestamp, "mp4"),
    ensureMediaProxyResponseOk(tsResponse, serverHost, serverPort, timestamp, "ts"),
  ])

  const [mp4Blob, tsText] = await Promise.all([mp4Response.blob(), tsResponse.text()])

  return { content: mp4Blob, ts: tsText, requested_timestamp: timestamp }
}
